import AppProvider from "./component/app-provider";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import routes from "./routes";
import Layout from "./component/layout";
import { useTranslation } from "react-i18next";
import PageNotFound from "./pages/page-not-found";
import "bootstrap/dist/css/bootstrap.min.css";
// Google Analytics
import ReactGA from "react-ga4";

function App() {
  const { i18n } = useTranslation();

  const router = createBrowserRouter([
    {
      element: <Layout />,
      errorElement: <PageNotFound />,
      // specify the routes defined in the
      // routing layer directly
      children: routes,
    },
  ]);

  // *************** Google Analytics ***************
  // Initialize Google Analytics with the provided tracking ID
  // ReactGA.initialize("");
  // Send a pageview event to Google Analytics to track the current page route
  // ReactGA.send({
  //   hitType: "pageview", // Specifies the type of hit being sent
  //   page: window.location.pathname, // Sets the page path to the current route
  // });
  // *************** End Google Analytics ***************

  return (
    <div dir={`${i18n.language === "ar" ? "rtl" : "ltr"}`}>
      <AppProvider>
        <RouterProvider router={router} />
        <ToastContainer rtl={i18n.language === "ar"} theme="colored" />
      </AppProvider>
    </div>
  );
}

export default App;
